import React from 'react';
import { Grid, Container, Divider } from '@material-ui/core';
import SubscribeForm from '../../form/SubscribeForm';
const row1 = [
	'About Us',
	'Our Team',
	'Sales Partners',
	'Careers We’re Hiring!',
	'Become A Sales Partner',
	'Podcast',
	'Video Blogs',
];
const row2 = [
	'Contact Us',
	'Travel Agents',
	'How To Book',
	'FAQ',
	'Leave Your Feedback',
	'Travel Guidelines 2023',
	'Customized Travel Planner',
	'COVID-19 Public Notice',
];
const row3 = [
	'Guests Reviews',
	'Blog',
	'Travel Planner',
	'Articles By Veena Patil',
	'Articles By Sunila Patil',
	'Travel Deals',
	'Tour Status',
	'Annual Return',
	'CSR Policy',
];
const Footer = () => {
	return (
		<>
			<div style={{ background: '#0E1E2C', padding: 40 }}>
				<Container>
					<Grid container>
						<Grid item xs={12} lg={6}>
							{/* <img src='https://www.veenaworld.com/assets/images/logo-dark-bg.svg' /> */}
							<h5 style={{ color: 'white', fontWeight: 'bold', marginTop: 30 }}>
								Keep travelling all year round!
							</h5>
							<p style={{ color: 'grey', fontSize: 14 }}>
								Subscribe to our newsletter to find travel inspiration in your
								inbox.
							</p>
							<SubscribeForm />
						</Grid>
						<Grid item xs={12} lg={6}>
							<Grid container>
								<Grid item xs={12} lg={4}>
									<h6
										style={{
											color: 'white',
											marginBottom: 20,
											fontWeight: 'bold',
											fontSize: 18,
										}}>
										Discover us
									</h6>
									{row1.map((r) => {
										return <p style={{ color: 'lightgrey' }}>{r}</p>;
									})}
								</Grid>
								<Grid item xs={12} lg={4}>
									<h6
										style={{
											color: 'white',
											marginBottom: 20,
											fontWeight: 'bold',
											fontSize: 18,
										}}>
										Support
									</h6>
									{row2.map((r) => {
										return <p style={{ color: 'lightgrey' }}>{r}</p>;
									})}
								</Grid>
								<Grid item xs={12} lg={4}>
									<h6
										style={{
											color: 'white',
											marginBottom: 20,
											fontWeight: 'bold',
											fontSize: 18,
										}}>
										Resources
									</h6>
									{row3.map((r) => {
										return <p style={{ color: 'lightgrey' }}>{r}</p>;
									})}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<Divider style={{ background: 'lightgrey' }} />
					<span
						style={{ color: 'lightgrey', fontWeight: 'bold', fontSize: 13 }}>
						*Caution: Beware of Fake Promotions or Offers
					</span>
					<p style={{ color: 'grey', fontSize: 12 }}>
						*Please do not believe or engage with any promotional emails, SMS or
						Web-link which ask you to click on a link and fill in your details.
						All Musafir Bazar authorized email communications are delivered from
						domain @musafirbazar.com or @musafirbazar.com or SMS
					</p>
					<p style={{ color: 'grey', fontSize: 12 }}>
						*Musafir Bazar bears no liability or responsibility whatsoever for
						any communication which is fraudulent or misleading in nature and
						not received from registered domain.
					</p>
					<Divider style={{ background: 'lightgrey' }} />
				</Container>
			</div>
		</>
	);
};

export default Footer;
